var margin1R = {
  "marginRight": "0.625rem !important"
};

export { margin1R };
